module.exports = `${require.publicPath}banner-img.c61f5ec5.jpg`;